/* eslint-disable no-unused-vars */
// import { setFeedback } from "../../store/slices/feedbackSlice";
import axios from "axios";
import store from "../../store/store";
import getTokenFromCookies from "../../utils/token";
axios.defaults.withCredentials = true;

export const callApi = async (config) => {
  const { url, method, data } = config;
  const state = store.getState();
  const token = getTokenFromCookies();
  // const token = state.auth.token; // Assuming your auth state holds the token

  try {
    const response = await axios({
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    const { message, response } = error;
    // store.dispatch(
    //   setFeedback({
    //     status: "fail",
    //     message: response?.data?.message || message,
    //     code: response?.status || null,
    //   })
    // );

    throw error;
  }
};
